import { render, staticRenderFns } from "./Sevaluation.vue?vue&type=template&id=524e674a&scoped=true&"
import script from "./Sevaluation.vue?vue&type=script&lang=js&"
export * from "./Sevaluation.vue?vue&type=script&lang=js&"
import style0 from "./Sevaluation.vue?vue&type=style&index=0&id=524e674a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e674a",
  null
  
)

export default component.exports